/**
 * @file
 * Add floating labels to base theme.
 */

// Base floating labels.
let $floatingLabels = $('.floating-labels', context);

$floatingLabels.once('floating-labels').each(function() {
  new FloatLabels($(this)[0], {
    prefix: 'fl-',
    prioritize: 'label',
    transform: 'input, textarea'
  });
});

// All User pages forms.
let $userPages = $('.form-item', context).filter(function() {
  return !!$(this).parents('.user-form, .user-login-form, .user-pass').length;
});

$userPages.once('floating-label-user').each(function() {
  let $this = $(this);

  new FloatLabels($this[0], {
    prefix: 'fl-',
    prioritize: 'label',
    transform: 'input, textarea'
  });

  // Fix Chrome bug with password field.
  if (/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
    setTimeout(function() {
      $this
        .find('input:-webkit-autofill')
        .parent('.fl-wrap')
        .addClass('fl-is-active');
    }, 200);
  }
});
